import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export const setSystemFlag = api(async function setSystemFlag({ flag, value }) {
    return mutate(
        gql`
            mutation setSystemFlag($flag: String!, $value: Boolean!) {
                setSystemFlag(flag: $flag, value: $value) {
                    hubspotDisabled
                }
            }
        `,
        { flag, value },
        { returns: "setSystemFlag" }
    )
})
